import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

import AcceptPrivacyPolicy from 'components/authentication/form-fields/AcceptPrivacyPolicy'
import passwordOutcome from 'components/authentication/passwordOutcome'
import { PasswordRules } from 'components/authentication/PasswordRules'
import SAMLRequired from 'components/authentication/registration/new-user/SAMLRequired'
import Button from 'components/common/Button'
import DividerWithText from 'components/common/DividerWithText'
import InputTextField from 'components/common/InputTextField'
import theme from 'theme'

export default class SetPassword extends React.Component {
  static propTypes = {
    location: PropTypes.object,
    handleChange: PropTypes.func,
    handleAcceptPrivacyPolicyChange: PropTypes.func,
    password: PropTypes.string,
    submitLabel: PropTypes.string,
    confirmPassword: PropTypes.string,
    privacyPolicyAccepted: PropTypes.bool,
    isLoading: PropTypes.bool,
    hideAcceptPrivacyPolicy: PropTypes.bool,
    includeSamlOption: PropTypes.bool,
    samlUrl: PropTypes.string
  }

  submitInvalid() {
    const { password, confirmPassword } = this.props
    return passwordOutcome(password, confirmPassword).some(
      (rule) => rule.invalid
    )
  }

  render() {
    const {
      password,
      confirmPassword,
      submitLabel,
      handleAcceptPrivacyPolicyChange,
      privacyPolicyAccepted,
      handleChange,
      isLoading,
      hideAcceptPrivacyPolicy,
      includeSamlOption,
      samlUrl,
      ...rest
    } = this.props

    return (
      <div className="formFields" {...rest}>
        <InputTextField
          label="Password"
          name="password"
          type="password"
          value={password}
          onChange={handleChange}
        />
        <InputTextField
          label="Confirm Password"
          name="confirmPassword"
          type="password"
          value={confirmPassword}
          onChange={handleChange}
        />
        <Box sx={{ mb: 4 }}>
          <PasswordRules
            passwordOutcome={passwordOutcome(password, confirmPassword)}
          />
        </Box>
        <Button
          data-test-submit-password
          stretch
          disabled={
            this.submitInvalid() ||
            (!hideAcceptPrivacyPolicy && !privacyPolicyAccepted)
          }
          label={submitLabel || 'Continue'}
          loading={isLoading}
          type="submit"
        />
        {includeSamlOption && (
          <>
            <DividerWithText>Or</DividerWithText>
            <SAMLRequired
              disabled={!hideAcceptPrivacyPolicy && !privacyPolicyAccepted}
              samlUrl={samlUrl}
            />
          </>
        )}
        {!hideAcceptPrivacyPolicy && (
          <AcceptPrivacyPolicy
            css={{ marginTop: theme.space[4] }}
            privacyPolicyAccepted={privacyPolicyAccepted}
            onChange={handleAcceptPrivacyPolicyChange}
          />
        )}
      </div>
    )
  }
}
